import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Convert implementation status code to human-readable label
 * Handles both snake_case codes and already formatted labels
 */
export function formatImplementationStatus(status: string | undefined | null): string {
  if (!status) return 'Not specified'
  
  const labelMap: Record<string, string> = {
    'fully_implemented': 'Fully Implemented',
    'partially_implemented': 'Partially Implemented',
    'not_implemented': 'Not Implemented',
    'unknown': 'Unknown',
    'fully': 'Fully Implemented',
    'partially': 'Partially Implemented',
    'not': 'Not Implemented',
  }
  
  const normalized = status.toLowerCase().trim()
  return labelMap[normalized] || status
}

/**
 * Format a number as currency (USD)
 */
export function formatCurrency(amount: number | string | null | undefined): string {
  if (amount === null || amount === undefined) return "—";
  const num = typeof amount === "string" ? parseFloat(amount) : amount;
  if (isNaN(num)) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(num);
}

/**
 * Format a date string or Date object
 */
export function formatDate(
  date: string | Date | null | undefined,
  options?: Intl.DateTimeFormatOptions
): string {
  if (!date) return "—";
  const d = typeof date === "string" ? new Date(date) : date;
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", options || {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
